import { render, staticRenderFns } from "./FeaturedBlocks.vue?vue&type=template&id=7298d52e&"
import script from "./FeaturedBlocks.vue?vue&type=script&lang=js&"
export * from "./FeaturedBlocks.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports